import './App.css';
import { AppRoutes } from '@/app/router.tsx';
import { AppProvider } from '@/app/provider.tsx';

function App() {
  return (
    <AppProvider>
      <AppRoutes />
    </AppProvider>
  );
}

export default App;
